import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import LoadingContent from '../../component/loading/LoadingContent';

import ProfileService from "../../service/Profile";
import actions from "../../redux/actions";
import FormProfile from "./FormProfile";

const Section = styled.section`
    height: 100%;
    & > .container{ 
        height: 100%;

        .form-container{
            background: #FCFDFF;
            border: 1px solid #DFE0EB;
            box-sizing: border-box;
            border-radius: 10px;
            padding: 40px 150px 40px 150px;
        }
    }
`;

export default function Index(props) {

    const [content, setContent] = useState(false)
    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(actions.master.setPath("/profile"))
        const init = async() =>{
            setContent(true)
        }

        init()
    }, [dispatch])

    return (
        <Section className={"section-user-profile" + (props.className ? props.className : "")}>
            <div className="container">
                {!content ? <LoadingContent />
                    :
                    <>
                        <div className="page-title">
                            <img src='/image/user.png' alt="icon-user"/>
                            <span>โปรไฟล์</span>
                        </div>
                        <div className="form-container">
                            <FormProfile />
                        </div>
                    </>
                }
            </div>
        </Section>
    )
}